import useSWRV from 'swrv';
import axios from 'axios';
import * as Cookie from 'tiny-cookie';

type TopicIdToStatus = Record<number, boolean>;

const fetchTopicBookmarkStatuses = (topicIds: number[]) => {
  return axios.post<{ topic_bookmarks: TopicIdToStatus }>(
    '/api/v3/bookmarks/topics_by_ids/',
    {
      topic_ids: topicIds.map(id => `${id}`),
    },
    {
      headers: { 'X-CSRFToken': Cookie.get('csrftoken') },
    },
  );
};

export const useTopicBookmarkStatusesWithSWRV = () => {
  const { data, mutate } = useSWRV<TopicIdToStatus>(
    'topic-bookmark-statuses',
    null as any,
  );

  const validateByTopicIds = async (userIds: number[]) => {
    try {
      const response = await fetchTopicBookmarkStatuses(userIds);
      mutate((): TopicIdToStatus => {
        return {
          ...data.value,
          ...response.data.topic_bookmarks,
        };
      });
    } catch {
      // pass
    }
  };

  const mutateStatusByTopicId = (topicId: number, status: boolean) => {
    mutate((): TopicIdToStatus => {
      return {
        ...data.value,
        [topicId]: status,
      };
    });
  };

  return {
    data,
    validateByTopicIds,
    mutateStatusByTopicId,
  };
};
